export const getClosingConsultationMessage = (doctor) => {
    const doctorName = doctor?.name;

    if (doctorName) {
        return `Based on the information you’ve shared, this is a preliminary assessment and guidance. For your safety, this will now be reviewed by your assigned doctor, Dr. ${doctorName}. The final recommendation will be shared once it has been verified and approved by Dr. ${doctorName}.`;
    }

    return `Based on the information you’ve shared, this is a preliminary assessment and guidance. For your safety, this will now be reviewed by a registered doctor. The final recommendation will be shared once it has been verified and approved.`;
};

export const getDoctorsName = (allDoctor, patientDoctorId) => {
    const doctor = allDoctor?.find(d => d._id === patientDoctorId);
    return doctor?.name || "";
};